import { Box, Card, CardContent, Typography, useTheme } from "@mui/material";
import BellIcon from "src/assets/icons/BellIcon";
import { useLocales } from "src/locales";

const BookingWaitlistCard = () => {
    const { translate } = useLocales();
    const theme = useTheme();

    return (
        <Card raised sx={{
            backgroundColor: theme.palette.background.neutral,
            mt: 4,
            borderRadius: "8px",
        }}>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: "center" }}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, pb: 1.5 }}>
                    <BellIcon />
                    <Typography variant="h5">
                        {translate("bookings.joinTheWaitlist")}
                    </Typography>
                </Box>
                <Typography variant="body1" align="center">
                    {translate("bookings.joinTheWaitlistDescription")}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default BookingWaitlistCard;